import React from 'react';
import { browserHistory } from 'react-router';
import validator from 'validator';
import Update from 'react-addons-update';
import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Drawer from 'material-ui/Drawer';
import getBrowserLanguage from 'get-browser-language';

import request from 'request';

/// Components

import Header from './components/Header.js';
import RothButton from './components/RothButton.js';
import ReactModal from 'react-modal';

/// Views

import WelcomePage from './views/WelcomePage.js';
import NewUserPage from './views/NewUserPage.js';
import ForgotPage from './views/ForgotPage.js';
import ProjectPage from './views/ProjectPage.js';
import RoomPage from './views/RoomPage.js';
import RoomsPage from './views/RoomsPage.js';
import DisclaimerPage from './views/DisclaimerPage.js';
import SummaryPage from './views/SummaryPage.js';
import CustomerPage from './views/CustomerPage.js';
import DonePage from './views/DonePage.js';

import './App.css';

/// data store, constants and App

var store = {
  ui: {
    page: '', // "" = welcome, "newUser", "forgot", "project", "rooms", "room", "disclaimer", "summary", "customer", "done"
    subPage: '',
    drawer: false,
    contactsFilled: false,
    scrollTop: 0,
    scrollTo: 0,
    disclaimerAccepted: false,
    forgotPasswordSent: false,
    newUserApplicationSent: false,
    error: '',
    showError: false
  },
  project: {
    heatSource: '',
    cabinet: '',
    manifold: '',
    regulationSystem: '',
    insulation: '',
    printPrices: true
  },
  rooms: [],
  user: {
    username: '',
    password: '',
    rememberPassword: false,
    departmentID: 100, //fi
    lang: '', // "fi", "sv", "dk", "no", "en". "" = auto detect
    name: '',
    phone: '',
    country: '',
    acceptTOS: false,
    currency: '€',
    showPrintPrices: true,
    company: ''
  },
  customer: {
    projectName: '',
    name: '',
    address: '',
    zip: '',
    city: '',
    phone: '',
    email: ''
  },
  response: {
    responseStatus: '',
    projectCode: 0,
    offerID: 0,
    offerCode: '',
    price: 0,
    pipeLength: 0,
    dataStatus: '',
    pdf: '',
    excel: '',
    updateChecksum: '',
    printChecksum: '',
    userLoggedIn: false,
    sessionHash: ''
  }
};

const constants = {
  selectOptions: {
    heatSource: ['default', 'noshunt', 'shunt', 'shuntunit', 'minishunt', 'minishuntWireless'],
    cabinet: ['default', 'cabinet', 'nocabinet'],
    manifold: ['default', 'noflowmeter', 'flowmeter'],
    regulationSystem: ['default', 'none', 'softline', 'basicline', 'basicline24v'],
    insulation: ['default', 'yes', 'no'],
    floorType: ['concrete', 'wooden', 'floating'],
    system: {
      default: [],
      concrete: ['clampTrack', 'steelWire', 'systemPlate', 'clips', 'knobPanel'],
      wooden: ['panel', 'selfSupport', 'silencio', 'plywood', 'joists'],
      floating: ['climaComfort', 'climaComfort16', 'compact', 'universal']
    },
    clips: ['clips', 'eps25', 'eps30', 'eps35', 'flipFix'],
    plywood: ['panel03', 'panel05'],
    joists: ['cc150', 'cc200'],
    knobPanel: ['knobPanel', 'eps10', 'eps30'],
    allowedPipes: {
      concrete: {
        clampTrack: ['pipe10mm', 'pipe16mm', 'pipe20mm'],
        steelWire: ['pipe10mm', 'pipe16mm', 'pipe20mm'],
        systemPlate: ['pipe16mm', 'pipe20mm'],
        clips: ['pipe10mm', 'pipe16mm', 'pipe20mm'],
        knobPanel: ['pipe16mm']
      },
      wooden: {
        panel: ['pipe16mm', 'pipe20mm'],
        selfSupport: ['pipe16mm', 'pipe20mm'],
        silencio: ['pipe16mm', 'pipe20mm'],
        plywood: ['pipe16mm'],
        joists: ['pipe16mm']
      },
      floating: {
        climaComfort: ['pipe10mm'],
        climaComfort16: ['pipe16mm'],
        compact: ['pipe10mm', 'pipe16mm'],
        universal: ['pipe16mm', 'pipe20mm']
      }
    },
    departments: [100, 101, 102, 103, 104]
  },
  maxMiniShuntRoomSizes: {
    pipe10mm: {
      clampTrack: 13,
      steelWire: 13,
      systemPlate: 13,
      clips: 13,
      knobPanel: 13,
      panel: 13,
      selfSupport: 13,
      silencio: 13,
      plywood: 13,
      joists: 13,
      climaComfort: 7,
      compact: 13,
      universal: 13
    },
    pipe16mm: {
      clampTrack: 30,
      steelWire: 30,
      systemPlate: 30,
      clips: 30,
      knobPanel: 20,
      panel: 30,
      selfSupport: 30,
      silencio: 30,
      plywood: 30,
      joists: 30,
      climaComfort: 30,
      climaComfort16: 30,
      compact: 20,
      universal: 30
    },
    pipe20mm: {
      clampTrack: 60,
      steelWire: 60,
      systemPlate: 60,
      clips: 60,
      knobPanel: 60,
      panel: 60,
      selfSupport: 60,
      silencio: 60,
      plywood: 60,
      joists: 60,
      climaComfort: 60,
      compact: 60,
      universal: 60
    }
  },
  newRoom: {
    name: '',
    area: 0.0,
    areaString: '',
    floorType: 'concrete',
    system: 'clampTrack',
    pipeDimension: 'pipe16mm',
    clips: 'clips', // only effective if system == clips
    plywood: 'panel03', // only effective if system == plywood
    joists: 'cc150', // only effective if system == joists
    knobPanel: 'knobPanel' // only effective if system == knobPanel
  },
  // all texts are fetched from server on init request. Welcome page default texts are here so those can be shown immediately, but will be overwritten with init request
  texts: {
    welcome: {
      h1: { en: 'Roth QuickCalc', sv: 'Roth QuickCalc', dk: 'Roth QuickCalc', no: 'Roth QuickCalc', fi: 'Roth QuickCalc' },
      desc: {
        en: 'Underfloor heating calculator',
        sv: 'Golvvärmekalkylator',
        dk: 'Gulvvarme beregner',
        no: 'Gulvvarme kalkulator',
        fi: 'Lattialämmitys laskuri'
      },
      i1: { en: 'E-mail', sv: 'E-mail', dk: 'E-mail', no: 'E-mail', fi: 'Sähköposti' },
      i2: { en: 'Password', sv: 'Lösenord', dk: 'Password', no: 'Passord', fi: 'Salasana' },
      i3: { en: 'Remember password', sv: 'Kom ihåg lösenord', dk: 'Husk password', no: 'Husk passord', fi: 'Muista salasana' },
      i4: { en: 'Forgot password?', sv: 'Glömt lösenord?', dk: 'Glemt password?', no: 'Glemt passord?', fi: 'Unohtuiko salasana?' },
      b1: { en: 'Sign in', sv: 'Logga in', dk: 'Log ind', no: 'Bekreft', fi: 'Kirjaudu sisään' },
      b2: { en: 'New user', sv: 'Ny användare', dk: 'ny bruger', no: 'Ny bruker', fi: 'Uusi käyttäjä' }
    },
    newUser: {},
    forgot: {},
    project: {},
    rooms: {},
    room: {},
    disclaimer: {},
    summary: {},
    customer: {},
    done: {},
    menu: {
      fi: { en: 'Suomi', sv: 'Suomi', dk: 'Suomi', no: 'Suomi', fi: 'Suomi' },
      sv: { en: 'Svenska', sv: 'Svenska', dk: 'Svenska', no: 'Svenska', fi: 'Svenska' },
      dk: { en: 'Dansk', sv: 'Dansk', dk: 'Dansk', no: 'Dansk', fi: 'Dansk' },
      no: { en: 'Norsk', sv: 'Norsk', dk: 'Norsk', no: 'Norsk', fi: 'Norsk' },
      en: { en: 'English', sv: 'English', dk: 'English', no: 'English', fi: 'English' }
    },
    other: {},
    error: {}
  },
  validations: {
    user: {
      username: function (val) {
        return validator.isEmail(val);
      },
      name: function (val) {
        return validator.isLength(val, { min: 1 });
      },
      phone: function (val) {
        return validator.isLength(val, { min: 5 }) && validator.isNumeric(val.replace('+', ''));
      },
      country: function (val) {
        return validator.isLength(val, { min: 2 });
      },
      company: function (val) {
        return validator.isLength(val, { min: 1 });
      }
    }
  },
  colorRed: '#d62631',
  colorGray: '#ebebeb',
  colorDarkGray: '#d1d1d1',
  colorWhite: '#ffffff',
  colorBlack: '#000000'
};

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: constants.colorRed,
    primary2Color: constants.colorRed,
    primary3Color: constants.colorRed,
    accent1Color: constants.colorGray,
    accent2Color: constants.colorGray,
    accent3Color: constants.colorGray,
    textColor: constants.colorBlack,
    alternateTextColor: constants.colorRed,
    canvasColor: constants.colorWhite,
    borderColor: constants.colorGray,
    disabledColor: constants.colorGray
  },
  appBar: {
    height: 50
  },
  flatButton: {
    color: constants.colorRed,
    textColor: constants.colorWhite,
    primaryTextColor: constants.colorRed,
    secondaryTextColor: constants.colorWhite
  }
});

var App = React.createClass({
  getInitialState() {
    console.log('App.init');
    return store;
  },
  componentWillMount() {
    console.log('App.willMount');

    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('RothQuickCalcState') !== null) {
      try {
        var lastState = JSON.parse(sessionStorage.getItem('RothQuickCalcState'));
        this.setStateUpdate({ $set: lastState });
      } catch (e) {
        console.log('Error: State parse');
        sessionStorage.removeItem('RothQuickCalcState');
      }
    }

    console.log('App.componentWillMount');

    if (this.state.user.lang === '') {
      var lang = getBrowserLanguage().substring(0, 2);
      console.log('Detected language from browser: ' + lang);
      if (lang !== 'en' && lang !== 'fi' && lang !== 'sv' && lang !== 'dk' && lang !== 'da' && lang !== 'no' && lang !== 'nn' && lang !== 'nb') {
        lang = 'en';
      }
      lang = lang === 'nb' || lang === 'nn' ? 'no' : lang; // Norwegian bogmål or Norwegian Nynorsk
      lang = lang === 'da' ? 'dk' : lang;
      this.setStateUpdate({ user: { lang: { $set: lang } } });
    }
    //console.log(this.props.routes);

    if ('page' in this.props.routes[0]) {
      if (
        !this.state.response.userLoggedIn &&
        this.props.routes[0].page !== '' &&
        this.props.routes[0].page !== 'newUser' &&
        this.props.routes[0].page !== 'forgot'
      ) {
        this.changePage('');
      }
      if ('subPage' in this.props.params) {
        this.changePage(this.props.routes[0].page, this.props.params.subPage);
      } else {
        this.changePage(this.props.routes[0].page);
      }
    }

    this.sendData('init');
  },
  componentWillReceiveProps(nextProps) {
    console.log('App.componentWillReceiveProps');
    //console.log(this.props.routes);
    //console.log(nextProps.routes);

    if ('page' in nextProps.routes[0]) {
      if (
        !this.state.response.userLoggedIn &&
        this.props.routes[0].page !== '' &&
        this.props.routes[0].page !== 'newUser' &&
        this.props.routes[0].page !== 'forgot'
      ) {
        this.changePage('');
      }
      if ('subPage' in nextProps.params) {
        this.setPageState(nextProps.routes[0].page, nextProps.params.subPage);
      } else {
        this.setPageState(nextProps.routes[0].page);
      }
      this.forceUpdate();
    }
  },
  // DO ALL STATE CHANGES WITH THIS
  setStateUpdate(updateStruct) {
    var updatedState = Update(this.state, updateStruct);
    this.setState(updatedState);
    this.state = updatedState; // this is maybe hack, but if state is used after setStateUpdate it will be the latest.
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('RothQuickCalcState', JSON.stringify(updatedState));
    }
  },

  logout() {
    var lang = this.state.user.lang;
    // remove session storage
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('RothQuickCalcState') !== null) {
      sessionStorage.removeItem('RothQuickCalcState');
    }
    this.setStateUpdate({ $set: store });
    this.setStateUpdate({ user: { lang: { $set: lang } } });
    this.changePage('');
  },
  login() {
    this.sendData('login');
  },
  startNewProject() {
    // remove session storage
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('RothQuickCalcState') !== null) {
      sessionStorage.removeItem('RothQuickCalcState');
    }
    var sessionHash = this.state.response.sessionHash;
    this.setStateUpdate({
      project: { $set: store.project },
      rooms: { $set: store.rooms },
      customer: { $set: store.customer },
      ui: { $set: store.ui },
      response: { $set: store.response }
    });
    this.setStateUpdate({
      response: { userLoggedIn: { $set: true }, sessionHash: { $set: sessionHash } }
    });
    this.addRoom();
    this.changePage('project');
  },
  createNewUser() {
    this.sendData('newUser');
    this.changePage('');
  },
  forgotPassword() {
    this.sendData('forgot');
  },
  sendRoth() {
    this.sendData('send');
    //    this.changePage("");
  },
  acceptDisclaimer() {
    this.setStateUpdate({ ui: { disclaimerAccepted: { $set: true } } });
    this.changePage('summary');
  },
  addRoom(lastRoomIndex) {
    console.log('lastRoomIndex ' + lastRoomIndex);
    var newValue = Object.assign({}, constants.newRoom);
    // copy some room params from last created room
    lastRoomIndex = lastRoomIndex === undefined ? this.state.rooms.length - 1 : Number(lastRoomIndex);

    if (lastRoomIndex >= 0 && lastRoomIndex < this.state.rooms.length) {
      newValue.floorType = this.state.rooms[lastRoomIndex].floorType;
      newValue.system = this.state.rooms[lastRoomIndex].system;
      newValue.pipeDimension = this.state.rooms[lastRoomIndex].pipeDimension;
      newValue.clips = this.state.rooms[lastRoomIndex].clips;
      newValue.plywood = this.state.rooms[lastRoomIndex].plywood;
      newValue.joists = this.state.rooms[lastRoomIndex].joists;
      newValue.knobPanel = this.state.rooms[lastRoomIndex].knobPanel;
    }
    var setStruct = { rooms: {} };
    var roomIndex = this.state.rooms.length;
    newValue.name = this.text('rooms', 'room') + ' ' + (roomIndex + 1);
    setStruct.rooms = { $push: [newValue] };
    this.setStateUpdate(setStruct);

    // just if this is first room, then create first allowed floor structure
    if (!(lastRoomIndex >= 0 && lastRoomIndex < this.state.rooms.length)) {
      this.changeRoomParam(roomIndex, 'floorType', newValue.floorType); // just to run some checks if floor type is not allowed
    }

    return roomIndex;
  },
  removeRoom(roomIndex) {
    var setStruct = { rooms: {} };
    setStruct.rooms = { $splice: [[roomIndex, 1]] };
    this.setStateUpdate(setStruct);
  },
  setPageState(newPage, newSubPage) {
    if (newPage !== this.state.ui.page) {
      // normal page change
      this.setStateUpdate({
        ui: {
          page: { $set: newPage },
          subPage: { $set: newSubPage },
          drawer: { $set: false },
          rnd: { $set: Math.random() },
          scrollTop: { $set: 0 },
          scrollTo: { $set: this.state.ui.scrollTop }
        }
      });
    } else {
      this.setStateUpdate({
        ui: {
          page: { $set: newPage },
          subPage: { $set: newSubPage },
          drawer: { $set: false }
        }
      });
    }
  },
  changePage(newPage, newSubPage) {
    if (newSubPage !== undefined && newSubPage !== '') {
      browserHistory.push('/' + newPage + '/' + newSubPage);
    } else {
      browserHistory.push('/' + newPage);
    }
    console.log('change page', newPage);
    console.log('change subpage', newSubPage);
    this.setPageState(newPage, newSubPage);
  },
  isPageAllowed(page, subPage) {
    // is all previous pages filled with valid data
    var welcomeValid = this.state.response.userLoggedIn;
    var projectValid = true;
    for (var pi in this.state.project) {
      if (
        (this.state.project[pi] === '' || this.state.project[pi] === 'default') &&
        !(pi === 'insulation' && this.state.project.cabinet === 'cabinet') &&
        !(pi === 'manifold' && this.state.project.heatSource === 'shuntunit') &&
        !(pi === 'manifold' && (this.state.project.heatSource === 'minishunt' || this.state.project.heatSource === 'minishuntWireless')) &&
        !(pi === 'regulationSystem' && (this.state.project.heatSource === 'minishunt' || this.state.project.heatSource === 'minishuntWireless'))
      ) {
        projectValid = false;
      }
    }
    var roomsValid = this.state.rooms.length > 0;
    for (var ri in this.state.rooms) {
      if (this.state.rooms[ri].area === 0) {
        roomsValid = false;
      }
    }
    var dislaimerValid = this.state.ui.disclaimerAccepted;
    var summaryValid = true;
    var customerValid = this.state.customer.projectName !== '';
    switch (page) {
      case '':
        return true;
      case 'newUser':
        return true;
      case 'forgot':
        return true;
      case 'project':
        return welcomeValid;
      case 'rooms':
        return welcomeValid && projectValid;
      case 'disclaimer':
        return welcomeValid && projectValid && roomsValid;
      case 'summary':
        return welcomeValid && projectValid && roomsValid && dislaimerValid;
      case 'customer':
        return welcomeValid && projectValid && roomsValid && dislaimerValid && summaryValid;
      case 'done':
        return welcomeValid && projectValid && roomsValid && dislaimerValid && summaryValid && customerValid;
      default:
    }
    return false;
  },
  changeProjectParam(param, newValue) {
    var setStruct = { project: {} };
    setStruct.project[param] = { $set: newValue };
    this.setStateUpdate(setStruct);
  },
  changeCustomerParam(param, newValue) {
    var setStruct = { customer: {} };
    setStruct.customer[param] = { $set: newValue };
    this.setStateUpdate(setStruct);
  },
  changeUserParam(param, newValue) {
    console.log('changeUserParam', param);
    console.log('changeUserParam', newValue);

    var allowChange = true;
    if (
      param === 'phone' &&
      !(
        validator.isNumeric(newValue) ||
        validator.isEmpty(newValue) ||
        (validator.isWhitelisted(newValue, '+0123456789') && (validator.isNumeric(newValue.substring(1)) || validator.isEmpty(newValue.substring(1))))
      )
    ) {
      allowChange = false;
    }
    if (param === 'email' && validator.contains(newValue, ' ')) {
      allowChange = false;
    }

    if (allowChange) {
      var setStruct = { user: {} };
      setStruct.user[param] = { $set: newValue };
      this.setStateUpdate(setStruct);
    }

    console.log(this.state.user);
  },
  changeRoomParam(roomNro, param, newValue) {
    var setStruct = { rooms: {} };
    setStruct.rooms[roomNro] = {};

    if (param === 'area') {
      var isLastComma = newValue.length > 0 && (newValue[newValue.length - 1] === '.' || newValue[newValue.length - 1] === ',');
      newValue = parseFloat(newValue.toString(10).replace(/[,]/g, '.'));
      newValue = Math.max(0, newValue);
      newValue = isNaN(newValue) ? 0 : newValue;
      newValue = Math.round(newValue * 10) / 10;
      // additional text version
      setStruct.rooms[roomNro].areaString = { $set: (newValue.toString(10) + (isLastComma ? ',' : '')).replace(/[.]/g, ',') };
    }
    setStruct.rooms[roomNro][param] = { $set: newValue };

    if (param === 'floorType') {
      setStruct.rooms[roomNro].system = { $set: '' };
      if (newValue === 'concrete') {
        for (let i = 0; i < constants.selectOptions.system.concrete.length; i++) {
          let structure = constants.selectOptions.system.concrete[i];
          if (structure in this.state.user.structures && this.state.user.structures[structure] === true) {
            setStruct.rooms[roomNro].system = { $set: structure };
            break;
          }
        }
      } else if (newValue === 'wooden') {
        for (let i = 0; i < constants.selectOptions.system.wooden.length; i++) {
          let structure = constants.selectOptions.system.wooden[i];
          if (structure in this.state.user.structures && this.state.user.structures[structure] === true) {
            setStruct.rooms[roomNro].system = { $set: structure };
            break;
          }
        }
      } else if (newValue === 'floating') {
        for (let i = 0; i < constants.selectOptions.system.floating.length; i++) {
          let structure = constants.selectOptions.system.floating[i];
          if (structure in this.state.user.structures && this.state.user.structures[structure] === true) {
            setStruct.rooms[roomNro].system = { $set: structure };
            break;
          }
        }
      }
    }
    this.setStateUpdate(setStruct);
    // check that pipe dimension is allowed
    var allowedPipes = constants.selectOptions.allowedPipes[this.state.rooms[Number(roomNro)].floorType][this.state.rooms[Number(roomNro)].system];
    if (allowedPipes.indexOf(this.state.rooms[roomNro].pipeDimension) === -1) {
      console.log(
        'This pipe dimension ' + this.state.rooms[roomNro].pipeDimension + ' is not available. Automatically changed to ' + allowedPipes[0]
      );
      setStruct = { rooms: {} };
      setStruct.rooms[roomNro] = { pipeDimension: { $set: allowedPipes[0] } };
      this.setStateUpdate(setStruct);
    }
    // check that area is still in limits
    var room = this.state.rooms[Number(roomNro)];
    if (
      ['minishunt', 'minishuntWireless'].includes(this.state.project.heatSource) &&
      room.area > constants.maxMiniShuntRoomSizes[room.pipeDimension][room.system]
    ) {
      var area = constants.maxMiniShuntRoomSizes[room.pipeDimension][room.system];
      setStruct = { rooms: {} };
      setStruct.rooms[roomNro] = {
        area: { $set: area },
        areaString: { $set: area.toString(10).replace(/[.]/g, ',') }
      };
      this.setStateUpdate(setStruct);

      return 'areaChanged';
    }
    return '';
  },
  changeLanguage(lang) {
    if (lang !== this.state.user.lang) {
      if (['fi', 'sv', 'dk', 'no', 'en'].includes(lang)) {
        this.setStateUpdate({ user: { lang: { $set: lang } }, ui: { drawer: { $set: false } } });
      } else {
        this.setStateUpdate({ user: { lang: { $set: 'en' } }, ui: { drawer: { $set: false } } });
      }
    }
  },
  text(groupName, stringName) {
    if (groupName in constants.texts && stringName in constants.texts[groupName]) {
      if (this.state.user.lang in constants.texts[groupName][stringName]) {
        return constants.texts[groupName][stringName][this.state.user.lang];
      } else if ('en' in constants.texts[groupName][stringName]) {
        return this.state.user.lang + ': ' + constants.texts[groupName][stringName].en;
      }
    }
    return 'TEXT ERROR: groupName, stringName';
  },
  handleToggleDrawer() {
    this.setStateUpdate({ ui: { drawer: { $set: !this.state.ui.drawer } } });
  },
  handleCloseDrawer() {
    this.setStateUpdate({ ui: { drawer: { $set: false } } });
  },
  validate(objectName, paramName) {
    if (this.state === undefined) return ' ';
    if (
      objectName in this.state &&
      paramName in this.state[objectName] &&
      objectName in constants.validations &&
      paramName in constants.validations[objectName]
    ) {
      if (constants.validations[objectName][paramName](this.state[objectName][paramName])) {
        return '';
      } else {
        return ' ';
      }
    } else return '';
  },

  calculateChecksum(data) {
    // adler32
    var dataStr = typeof data === 'undefined' ? '' : JSON.stringify(data);
    var a = 1,
      b = 0;

    for (var i = 0; i < dataStr.length; i++) {
      a = (a + dataStr.charCodeAt(i)) % 65521;
      b = (b + a) % 65521;
    }

    return a | (b << 16);
  },

  sendData(action) {
    // actions: "createOrUpdate", "print"

    console.log(this.state);

    //var headers = new Headers();
    var url = require('url');
    var href = document.location.href;
    var urlObj = url.parse(href, true);
    // quick fix for dev
    var domain = urlObj.host === 'localhost:3000' ? 'quickcalc.roth.test' : urlObj.host;

    var host = urlObj.protocol + '//' + domain;

    var updateData = {
      user: this.state.user,
      projectCode: this.state.response.projectCode,
      offerID: this.state.response.offerID,
      offerCode: this.state.response.offerCode,
      project: this.state.project,
      rooms: this.state.rooms,
      userLoggedIn: this.state.response.userLoggedIn,
      departmentID: this.state.user.departmentID,
      sessionHash: this.state.response.sessionHash
    };
    var updateChecksum = this.calculateChecksum(updateData);

    var printData = {
      user: this.state.user,
      projectCode: this.state.response.projectCode,
      offerID: this.state.response.offerID,
      offerCode: this.state.response.offerCode,
      project: this.state.project,
      customer: this.state.customer,
      userLoggedIn: this.state.response.userLoggedIn,
      departmentID: this.state.user.departmentID,
      sessionHash: this.state.response.sessionHash
    };
    var printChecksum = this.calculateChecksum(printData);

    var updateAndPrintData = {
      user: this.state.user,
      projectCode: this.state.response.projectCode,
      offerID: this.state.response.offerID,
      offerCode: this.state.response.offerCode,
      project: this.state.project,
      rooms: this.state.rooms,
      customer: this.state.customer,
      userLoggedIn: this.state.response.userLoggedIn,
      departmentID: this.state.user.departmentID,
      sessionHash: this.state.response.sessionHash
    };

    var query = null;

    if (action === 'init') {
      this.setStateUpdate({
        response: {
          responseStatus: { $set: 'waiting' },
          dataStatus: { $set: '' },
          sentToRoth: { $set: false }
          //          userLoggedIn: {$set: false},
        }
      });
      query = {
        action: 'init',
        data: {}
      };
    } else if (action === 'login') {
      this.setStateUpdate({
        response: {
          responseStatus: { $set: 'waiting' },
          dataStatus: { $set: '' },
          sentToRoth: { $set: false },
          userLoggedIn: { $set: false },
          sessionHash: { $set: '' }
        }
      });
      query = {
        action: 'login',
        data: { username: this.state.user.username, password: this.state.user.password }
      };
    } else if (action === 'forgot') {
      this.setStateUpdate({
        response: {
          responseStatus: { $set: 'waiting' },
          dataStatus: { $set: '' },
          sentToRoth: { $set: false },
          userLoggedIn: { $set: false }
        }
      });
      query = {
        action: 'forgot',
        data: {
          username: this.state.user.username,
          departmentID: this.state.user.departmentID, //fi
          lang: this.state.user.lang, // "fi", "sv", "dk", "no", "en"
          name: this.state.user.name,
          phone: this.state.user.phone,
          company: this.state.user.company
        }
      };
    } else if (action === 'newUser') {
      this.setStateUpdate({
        response: {
          responseStatus: { $set: 'waiting' },
          dataStatus: { $set: '' },
          sentToRoth: { $set: false },
          userLoggedIn: { $set: false }
        }
      });
      query = {
        action: 'newUser',
        data: {
          username: this.state.user.username,
          departmentID: this.state.user.departmentID, //fi
          lang: this.state.user.lang, // "fi", "sv", "dk", "no", "en"
          name: this.state.user.name,
          phone: this.state.user.phone,
          company: this.state.user.company
        }
      };
    } else if (action === 'send') {
      this.setStateUpdate({
        response: {
          responseStatus: { $set: 'waiting' },
          sentToRoth: { $set: false },
          dataStatus: { $set: '' }
        }
      });
      query = {
        action: 'send',
        data: {
          username: this.state.user.username,
          departmentID: this.state.user.departmentID, //fi
          lang: this.state.user.lang, // "fi", "sv", "dk", "no", "en"
          name: this.state.user.name,
          phone: this.state.user.phone,
          projectCode: this.state.response.projectCode,
          offerID: this.state.response.offerID,
          offerCode: this.state.response.offerCode,
          projectName: this.state.customer.projectName
        }
      };
    } else if (action === 'createOrUpdate' && (updateChecksum !== this.state.response.updateChecksum || this.state.response.offerID === 0)) {
      // project is new or need update, so lets clean old data
      this.setStateUpdate({
        response: {
          responseStatus: { $set: 'waiting' },
          dataStatus: { $set: '' },
          price: { $set: 0 },
          pipeLength: { $set: 0 },
          pdf: { $set: '' },
          excel: { $set: '' },
          updateChecksum: { $set: '' },
          printChecksum: { $set: '' },
          sentToRoth: { $set: false }
        }
      });
      query = {
        action: 'createOrUpdate',
        data: updateData
      };
    } else if (action === 'print' && (updateChecksum !== this.state.response.updateChecksum || this.state.response.offerID === 0)) {
      // print and create or update
      // project is new or need update, so lets clean old data before print
      this.setStateUpdate({
        response: {
          responseStatus: { $set: 'waiting' },
          dataStatus: { $set: '' },
          price: { $set: 0 },
          pipeLength: { $set: 0 },
          pdf: { $set: '' },
          excel: { $set: '' },
          updateChecksum: { $set: '' },
          printChecksum: { $set: '' },
          sentToRoth: { $set: false }
        }
      });
      query = {
        action: 'updateAndPrint',
        data: updateAndPrintData
      };
    } else if (action === 'print' && printChecksum !== this.state.response.printChecksum) {
      // project is unchanged so just print (customer data is updated anyway)
      // project is already done, so just print
      this.setStateUpdate({
        response: {
          responseStatus: { $set: 'waiting' },
          dataStatus: { $set: '' },
          pdf: { $set: '' },
          excel: { $set: '' },
          printChecksum: { $set: '' },
          sentToRoth: { $set: false }
        }
      });
      query = {
        action: 'print',
        data: printData
      };
    }

    if (query !== null) {
      // so there is need to ask something from server
      try {
        request(
          {
            method: 'POST',
            url: host + '/api/',
            body: JSON.stringify(query),
            headers: {
              'Content-Type': 'text/plain'
            }
          },
          function (error, response, body) {
            if (error === null) {
              var resp = JSON.parse(response.body);
              var respStatus = 'status' in resp ? resp.status : 'error';
              if (respStatus === 'ok') {
                var dataStatus = 'data' in resp && 'status' in resp.data ? resp.data.status : 'error';
                if (dataStatus === 'ok') {
                  // OK
                  this.setStateUpdate({
                    response: {
                      responseStatus: { $set: 'ok' },
                      dataStatus: { $set: 'ok' }
                    }
                  });

                  if (query.action === 'init') {
                    console.log('INIT RESPONSE');
                    console.log(resp.data);
                    var textResponseOK = true;
                    Object.keys(constants.texts).forEach(function (key, index) {
                      if (!(key in resp.data.texts)) {
                        textResponseOK = false;
                      }
                    });
                    if (textResponseOK) {
                      Object.keys(constants.texts).forEach(function (key, index) {
                        constants.texts[key] = resp.data.texts[key];
                      });
                      console.log(constants);
                    } else {
                      this.showError('texts corrupted');
                    }
                    this.forceUpdate();
                  } else if (query.action === 'login') {
                    //console.log("login state");
                    //console.log(this.state);
                    this.setStateUpdate({
                      response: {
                        userLoggedIn: { $set: true },
                        sessionHash: { $set: resp.data.sessionHash }
                      },
                      user: {
                        departmentID: { $set: resp.data.departmentID },
                        password: { $set: this.state.user.rememberPassword ? this.state.user.password : '' },
                        currency: { $set: resp.data.currency },
                        structures: { $set: resp.data.structures },
                        showPrintPrices: { $set: resp.data.showPrintPrices },
                        name: { $set: resp.data.name },
                        phone: { $set: resp.data.phone }
                      }
                    });
                    //console.log(this.state);
                    this.startNewProject();
                  } else if (query.action === 'forgot') {
                    this.setStateUpdate({ ui: { forgotPasswordSent: { $set: true } } });
                    this.changePage('');
                  } else if (query.action === 'newUser') {
                    this.setStateUpdate({ ui: { newUserApplicationSent: { $set: true } } });
                  }

                  if (query.action === 'createOrUpdate') {
                    this.setStateUpdate({
                      response: {
                        projectCode: { $set: resp.data.projectCode },
                        offerID: { $set: resp.data.offerID },
                        offerCode: { $set: resp.data.offerCode },
                        price: { $set: resp.data.price },
                        pipeLength: { $set: resp.data.pipeLength },
                        pdf: { $set: '' },
                        excel: { $set: '' },
                        updateChecksum: { $set: updateChecksum },
                        printChecksum: { $set: '' }
                      }
                    });
                  } else if (query.action === 'updateAndPrint' || query.action === 'print') {
                    this.setStateUpdate({
                      response: {
                        projectCode: { $set: resp.data.projectCode },
                        offerID: { $set: resp.data.offerID },
                        offerCode: { $set: resp.data.offerCode },
                        price: { $set: resp.data.price },
                        pipeLength: { $set: resp.data.pipeLength },
                        pdf: { $set: resp.data.pdf },
                        excel: { $set: resp.data.excel },
                        updateChecksum: { $set: updateChecksum },
                        printChecksum: { $set: printChecksum }
                      }
                    });
                  } else if (query.action === 'send') {
                    this.setStateUpdate({
                      response: { sentToRoth: { $set: true } }
                    });
                  }
                  console.log('sendData: OK');
                } else {
                  // Data status ERROR
                  this.setStateUpdate({
                    response: {
                      responseStatus: { $set: respStatus },
                      dataStatus: { $set: dataStatus },
                      pdf: { $set: '' },
                      excel: { $set: '' },
                      updateChecksum: { $set: '' },
                      printChecksum: { $set: '' }
                    }
                  });
                  console.log('response status: ', respStatus);
                  console.log('data status: ', dataStatus);
                  this.showError('data error');

                  try {
                    fetch('/pro/error', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json; charset=utf-8'
                      },
                      body: JSON.stringify({ respStatus, dataStatus })
                    })
                      .then(response => {
                        if (!response.ok) {
                          throw new Error('Network response was not ok');
                        }
                        return response.json();
                      })
                      .then(data => {
                        console.log(data);
                      })
                      .catch(error => {
                        console.error('There was a problem with the fetch operation:', error);
                      });
                  } catch (e) {
                    console.log(e);
                  }
                }
              } else {
                // Response status ERROR
                this.setStateUpdate({
                  response: {
                    responseStatus: { $set: respStatus },
                    dataStatus: { $set: '' },
                    pdf: { $set: '' },
                    excel: { $set: '' },
                    updateChecksum: { $set: '' },
                    printChecksum: { $set: '' }
                  }
                });
                console.log('response status: ', respStatus);
                this.showError(respStatus);

                try {
                  fetch('/pro/error', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json; charset=utf-8'
                    },
                    body: JSON.stringify({ respStatus })
                  })
                    .then(response => {
                      if (!response.ok) {
                        throw new Error('Network response was not ok');
                      }
                      return response.json();
                    })
                    .then(data => {
                      console.log(data);
                    })
                    .catch(error => {
                      console.error('There was a problem with the fetch operation:', error);
                    });
                } catch (e) {
                  console.log(e);
                }
              }
            } else {
              // Connection ERROR
              this.setStateUpdate({
                response: {
                  responseStatus: { $set: 'error: ' + error },
                  dataStatus: { $set: '' },
                  pdf: { $set: '' },
                  excel: { $set: '' },
                  updateChecksum: { $set: '' },
                  printChecksum: { $set: '' }
                }
              });
              console.log('error', error);
              this.showError('connection error');
            }
            //console.log(this.state.response);
          }.bind(this)
        );
      } catch (e) {
        // Some unknown error
        this.setStateUpdate({
          response: {
            responseStatus: { $set: 'error: ' + e },
            dataStatus: { $set: '' },
            pdf: { $set: '' },
            excel: { $set: '' },
            updateChecksum: { $set: '' },
            printChecksum: { $set: '' }
          }
        });
        console.log('error', e);
        this.showError('unknown error');
      }
    }
  },
  showError(msg) {
    if (msg in constants.texts.error) {
      this.setStateUpdate({ ui: { error: { $set: this.text('error', msg) } } });
    } else {
      this.setStateUpdate({ ui: { error: { $set: 'error' } } });
    }
    this.setStateUpdate({ ui: { showError: { $set: true } } });
  },
  handleErrorDialogOK() {
    this.setStateUpdate({ ui: { showError: { $set: false } } });
  },
  render() {
    console.log('App.render');
    var pageName = this.state.ui.page;
    var subPageName = this.state.ui.subPage;

    var page = <WelcomePage changePage={this.changePage} constants={constants} />;
    switch (pageName) {
      case '':
        page = (
          <WelcomePage
            user={this.state.user}
            changePage={this.changePage}
            changeUserParam={this.changeUserParam}
            text={this.text}
            login={this.login}
            responseStatus={this.state.response.responseStatus}
            isPageAllowed={this.isPageAllowed}
            constants={constants}
          />
        );
        break;
      case 'newUser':
        page = (
          <NewUserPage
            user={this.state.user}
            createNewUser={this.createNewUser}
            newUserApplicationSent={this.state.ui.newUserApplicationSent}
            changePage={this.changePage}
            changeUserParam={this.changeUserParam}
            options={constants.selectOptions}
            page={pageName}
            text={this.text}
            validate={this.validate}
            backPage={''}
            isPageAllowed={this.isPageAllowed}
            constants={constants}
          />
        );
        break;
      case 'forgot':
        page = (
          <ForgotPage
            user={this.state.user}
            forgotPassword={this.forgotPassword}
            forgotPasswordSent={this.state.ui.forgotPasswordSent}
            changePage={this.changePage}
            changeUserParam={this.changeUserParam}
            options={constants.selectOptions}
            page={pageName}
            text={this.text}
            validate={this.validate}
            backPage={''}
            isPageAllowed={this.isPageAllowed}
            constants={constants}
          />
        );
        break;
      case 'project':
        page = (
          <ProjectPage
            project={this.state.project}
            changeProjectParam={this.changeProjectParam}
            changePage={this.changePage}
            page={pageName}
            text={this.text}
            options={constants.selectOptions}
            backPage={''}
            isPageAllowed={this.isPageAllowed}
            constants={constants}
          />
        );
        break;
      case 'rooms':
        page = (
          <RoomsPage
            rooms={this.state.rooms}
            addRoom={this.addRoom}
            removeRoom={this.removeRoom}
            changePage={this.changePage}
            page={pageName}
            subPage={subPageName}
            text={this.text}
            options={constants.selectOptions}
            oneRoomOnly={['minishunt', 'minishuntWireless'].includes(this.state.project.heatSource)}
            backPage={'project'}
            isPageAllowed={this.isPageAllowed}
            constants={constants}
          />
        );
        break;
      case 'room':
        page = (
          <RoomPage
            room={this.state.rooms[subPageName]}
            addRoom={this.addRoom}
            changeRoomParam={this.changeRoomParam}
            changePage={this.changePage}
            page={pageName}
            subPage={subPageName}
            text={this.text}
            options={constants.selectOptions}
            structures={this.state.user.structures}
            oneRoomOnly={['minishunt', 'minishuntWireless'].includes(this.state.project.heatSource)}
            maxMiniShuntRoomSizes={constants.maxMiniShuntRoomSizes}
            backPage={'rooms'}
            isPageAllowed={this.isPageAllowed}
            constants={constants}
            departmentID={this.state.user.departmentID}
          />
        );
        break;
      case 'disclaimer':
        page = (
          <DisclaimerPage
            changePage={this.changePage}
            acceptDisclaimer={this.acceptDisclaimer}
            page={pageName}
            subPage={subPageName}
            text={this.text}
            backPage={'rooms'}
            isPageAllowed={this.isPageAllowed}
            constants={constants}
          />
        );
        break;
      case 'summary':
        page = (
          <SummaryPage
            project={this.state.project}
            rooms={this.state.rooms}
            changePage={this.changePage}
            changeProjectParam={this.changeProjectParam}
            page={pageName}
            text={this.text}
            sendData={this.sendData}
            response={this.state.response}
            optionTexts={constants.selectOptions}
            backPage={'disclaimer'}
            isPageAllowed={this.isPageAllowed}
            currency={this.state.user.currency}
            showPrintPrices={this.state.user.showPrintPrices}
            constants={constants}
          />
        );
        break;
      case 'customer':
        page = (
          <CustomerPage
            customer={this.state.customer}
            changeCustomerParam={this.changeCustomerParam}
            changePage={this.changePage}
            page={pageName}
            text={this.text}
            validate={this.validate}
            backPage={'summary'}
            isPageAllowed={this.isPageAllowed}
            constants={constants}
          />
        );
        break;
      case 'done':
        page = (
          <DonePage
            changePage={this.changePage}
            page={pageName}
            text={this.text}
            sendData={this.sendData}
            sendRoth={this.sendRoth}
            response={this.state.response}
            projectName={this.state.customer.projectName}
            startNewProject={this.startNewProject}
            backPage={'customer'}
            constants={constants}
            isPageAllowed={this.isPageAllowed}
            logout={this.logout}
          />
        );
        break;
      default:
        page = <WelcomePage changePage={this.changePage} text={this.text} />;
    }

    var className = 'page page-' + pageName;

    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div>
          <div className={className}>
            {pageName !== '' && pageName !== 'done' ? <Header handleToggleDrawer={this.handleToggleDrawer} /> : <span />}
            <div className="pageInner">
              <div className="contentBackground">
                {page}
                <ReactModal
                  isOpen={this.state.ui.showError}
                  contentLabel=""
                  style={{
                    content: {
                      position: 'absolute',
                      top: '30%',
                      width: 'calc(100% - 80px)',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      height: '300px',
                      border: '0px solid white',
                      backgroundColor: constants.colorRed,
                      borderRadius: '22px',
                      padding: '40px 10px',
                      maxWidth: '500px'
                    }
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                    <div style={{ textAlign: 'center', color: 'white', fontSize: '30px', whiteSpace: 'pre-wrap' }}>{this.state.ui.error}</div>
                    <div style={{ textAlign: 'center' }}>
                      <RothButton type="halfWhite" fn={this.handleErrorDialogOK}>
                        OK
                      </RothButton>
                    </div>
                  </div>
                </ReactModal>
              </div>
            </div>
            <Drawer
              docked={false}
              width={400}
              open={this.state.ui.drawer}
              onRequestChange={open => this.setStateUpdate({ ui: { drawer: { $set: open } } })}
              style={{ textAlign: 'center', fontSize: '12px' }}
            >
              <br />
              <br />
              <h2>
                <RothButton
                  type="text"
                  fn={this.changePage}
                  value={''}
                  disabled={!this.isPageAllowed('')}
                  style={this.state.ui.page === '' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'welcome')}
                </RothButton>
              </h2>
              <h2>
                <RothButton
                  type="text"
                  fn={this.changePage}
                  value={'project'}
                  disabled={!this.isPageAllowed('project')}
                  style={this.state.ui.page === 'project' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'project')}
                </RothButton>
              </h2>
              <h2>
                <RothButton
                  type="text"
                  fn={this.changePage}
                  value={'rooms'}
                  disabled={!this.isPageAllowed('rooms')}
                  style={this.state.ui.page === 'rooms' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'rooms')}
                </RothButton>
              </h2>
              <h2>
                <RothButton
                  type="text"
                  fn={this.changePage}
                  value={'summary'}
                  disabled={!this.isPageAllowed('summary')}
                  style={this.state.ui.page === 'summary' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'summary')}
                </RothButton>
              </h2>
              <h2>
                <RothButton
                  type="text"
                  fn={this.changePage}
                  value={'customer'}
                  disabled={!this.isPageAllowed('customer')}
                  style={this.state.ui.page === 'customer' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'customer')}
                </RothButton>
              </h2>
              <h2>
                <RothButton
                  type="text"
                  fn={this.changePage}
                  value={'done'}
                  disabled={!this.isPageAllowed('done')}
                  style={this.state.ui.page === 'done' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'done')}
                </RothButton>
              </h2>
              <br />
              <br />
              <h2>
                <RothButton
                  type="text"
                  fn={val => this.changeLanguage(val)}
                  value={'en'}
                  style={this.state.user.lang === 'en' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'en')}
                </RothButton>
              </h2>
              <h2>
                <RothButton
                  type="text"
                  fn={val => this.changeLanguage(val)}
                  value={'fi'}
                  style={this.state.user.lang === 'fi' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'fi')}
                </RothButton>
              </h2>
              <h2>
                <RothButton
                  type="text"
                  fn={val => this.changeLanguage(val)}
                  value={'sv'}
                  style={this.state.user.lang === 'sv' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'sv')}
                </RothButton>
              </h2>
              <h2>
                <RothButton
                  type="text"
                  fn={val => this.changeLanguage(val)}
                  value={'dk'}
                  style={this.state.user.lang === 'dk' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'dk')}
                </RothButton>
              </h2>
              <h2>
                <RothButton
                  type="text"
                  fn={val => this.changeLanguage(val)}
                  value={'no'}
                  style={this.state.user.lang === 'no' ? { color: constants.colorRed } : {}}
                >
                  {this.text('menu', 'no')}
                </RothButton>
              </h2>
              <br />
              <br />
              <h2>
                <RothButton type="text" fn={this.logout} value={'done'}>
                  {this.text('menu', 'logout')}
                </RothButton>
              </h2>
            </Drawer>
          </div>
        </div>
      </MuiThemeProvider>
    );
  },
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.route.page !== prevState.ui.page) {
      //console.log("scrollTo", this.state.ui.scrollTo);
      window.scrollTo(0, this.state.ui.scrollTo);
    }
  }
});

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/